module.exports = __webpack_public_path__ + "static/media/Avatars_Male-02.49b9b269.png";